const values = [
  {
    icon: 'ri-message-3-fill',
    title: 'Clear Communication',
    description:
      'We explain what needs to be done and why — in plain language. No jargon, no pressure, no surprises on your bill.',
    tag: 'Customer First',
  },
  {
    icon: 'ri-lightbulb-fill',
    title: 'Honest Recommendations',
    description:
      'We tell you what your home actually needs — not what pads our invoice. If something can wait, we\'ll say so.',
    tag: 'No Upselling',
  },
  {
    icon: 'ri-tools-fill',
    title: 'Clean Workmanship',
    description:
      'We run wiring like it matters — because it does. Organized panels, clean installs, and finished work that reflects pride.',
    tag: 'Quality Standard',
  },
  {
    icon: 'ri-home-heart-fill',
    title: 'Respect for Your Home',
    description:
      'Boots off if asked. Drop cloths down. Trash removed. We treat your space like it\'s ours — because that\'s just how it should be.',
    tag: 'Home Respect',
  },
  {
    icon: 'ri-file-list-3-fill',
    title: 'Code-Compliant Always',
    description:
      'Every installation meets or exceeds Michigan electrical code. We don\'t cut corners on inspections or documentation.',
    tag: 'Safety Standard',
  },
  {
    icon: 'ri-user-star-fill',
    title: 'Professionalism End-to-End',
    description:
      'From the first call to the final walkthrough — we show up on time, dressed professionally, and treat every job like it\'s our most important.',
    tag: 'Full Commitment',
  },
];

const ValuesSection = () => (
  <section className="relative bg-pg py-28 overflow-hidden">
    {/* Glow accent top */}
    <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[1px] bg-gradient-to-r from-transparent via-[#00D9FF]/25 to-transparent" />

    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      {/* Section header */}
      <div className="max-w-2xl mb-16 scroll-reveal">
        <span className="inline-block text-[#00D9FF] text-[11px] font-bold tracking-[3px] uppercase mb-4">
          Why Clients Choose Us
        </span>
        <h2 className="text-4xl md:text-5xl font-black text-[var(--tp)] leading-tight tracking-tight">
          Values That Show Up
          <br />
          <span className="text-[var(--tm)]">on Every Job.</span>
        </h2>
      </div>

      {/* Values grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-px bg-[var(--bd)] rounded-2xl overflow-hidden border border-[var(--bd)]">
        {values.map((v, i) => (
          <div
            key={v.title}
            className={`scroll-reveal scroll-delay-${Math.min(i + 1, 6)} group relative bg-pg p-8 transition-all duration-300 hover:bg-cr overflow-hidden`}
          >
            {/* Hover glow corner */}
            <div className="absolute top-0 left-0 w-24 h-24 bg-[#00D9FF]/0 group-hover:bg-[#00D9FF]/5 rounded-br-full transition-colors duration-500" />

            {/* Tag */}
            <span className="inline-block text-[#00D9FF]/80 text-[10px] font-bold tracking-[2px] uppercase mb-5 border border-[#00D9FF]/25 px-2.5 py-1 rounded-full">
              {v.tag}
            </span>

            {/* Icon */}
            <div className="w-12 h-12 flex items-center justify-center bg-[#00D9FF]/10 group-hover:bg-[#00D9FF]/15 rounded-xl mb-5 transition-colors duration-300">
              <i className={`${v.icon} text-[#00D9FF] text-xl`} />
            </div>

            {/* Content */}
            <h3 className="text-[var(--tp)] font-bold text-[17px] mb-3 leading-snug">{v.title}</h3>
            <p className="text-[var(--tm)] text-[14px] leading-relaxed">{v.description}</p>

            {/* Number watermark */}
            <div className="absolute top-4 right-6 text-[var(--bd)] font-black text-6xl leading-none select-none">
              {String(i + 1).padStart(2, '0')}
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default ValuesSection;
